export const DEFAULT_TICKER_WIDTH = "100";

/**
 * Ticker width is stored as a bare percentage number ("100", "72.5") because
 * every consumer appends the "%" unit itself. Values that already carry the
 * unit would otherwise render as `width: 100%%`, which is invalid CSS and
 * collapses the element. Older entities (and the previous "100%" default)
 * still carry it, so normalize on the way in.
 */
export const normalizeTickerWidth = (width: unknown): string => {
  if (typeof width === "number") {
    return Number.isFinite(width) ? String(width) : DEFAULT_TICKER_WIDTH;
  }

  if (typeof width !== "string") return DEFAULT_TICKER_WIDTH;

  const parsed = Number.parseFloat(width.trim());
  return Number.isFinite(parsed) ? String(parsed) : DEFAULT_TICKER_WIDTH;
};
